import Api from '../api/reconApi.js';
import * as getInfo from './apiGetInfo';

export function addCatalogPart(data, errorType) {
	if (data.id) {
		return dispatch => Api.patchData(`catalog_parts/${data.id}`, data).then(resp => dispatch(getInfo.getCatalogParts())).catch(ex => Api.handleApiError(ex, errorType));
	}
	return dispatch => Api.postData('catalog_parts/', data).then(resp => dispatch(getInfo.getCatalogParts())).catch(ex => Api.handleApiError(ex, errorType));
}

export function importCatalogPart(data) {
	return async () => {
		const resp = await Api.postData('catalog_parts/', data);
		const part = resp?.data?.data || {};
		const defaults = {};
		['labor_units', 'labor_total', 'total'].forEach((key) => {
			if (data[key] !== undefined && data[key] !== null) defaults[key] = data[key];
		});
		if (part.id && resp?.status === 200 && Object.keys(defaults).length > 0) {
			await Api.patchData(`catalog_parts/${part.id}`, defaults);
		}
		return part;
	};
}

export function updateCatalogPart(id, data, errorType) {
	return dispatch => Api.patchData(`catalog_parts/${id}`, data).then(() => {
		dispatch(getInfo.getCatalogParts());
	}).catch(ex => Api.handleApiError(ex, errorType));
}

export function updateCatalogPartRaw(id, data, errorType) {
	return dispatch => Api.patchData(`catalog_parts/${id}`, data).then(() => {}).catch(ex => Api.handleApiError(ex, errorType));
}

export function softDeleteCatalogPart(id, errorType) {
	return dispatch => Api.patchData(`catalog_parts/${id}`, { deleted: true }).then(() => {
		dispatch(getInfo.getCatalogParts());
		return 'success';
	}).catch(ex => Api.handleApiError(ex, errorType));
}
